import React from "react";

type Props = { className?: string; size?: number };

const TeamIcon: React.FC<Props> = ({ className, size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.906 9.08a2.396 2.396 0 0 0 2.06-2.367c0-1.19-.867-2.177-2.005-2.363M16.44 11.875c1.126.169 1.912.563 1.912 1.375 0 .56-.37.923-.969 1.151"
    />
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.905 12.22c-2.678 0-4.966.406-4.966 2.026 0 1.62 2.274 2.038 4.966 2.038 2.679 0 4.965-.402 4.965-2.023 0-1.622-2.272-2.041-4.965-2.041ZM9.905 9.907a3.182 3.182 0 1 0-3.182-3.183 3.17 3.17 0 0 0 3.159 3.183h.023Z"
      clipRule="evenodd"
    />
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.904 9.08a2.396 2.396 0 0 1-2.06-2.367c0-1.19.867-2.177 2.005-2.363M3.37 11.875c-1.126.169-1.912.563-1.912 1.375 0 .56.37.923.968 1.151"
    />
  </svg>
);

export default TeamIcon;
